<template>
  <img
    :class="classes"
    :src="image.src"
    :style="styles"
    :alt="image.alt"
  />
</template>

<script>
export default {
  name: 'BaseAvatar',

  props: {
    image: {
      type: Object,
      required: true,
    },

    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return ['regular', 'large'].includes(value)
      },
    },
  },

  computed: {
    classes() {
      return {
        BaseAvatar: true,
        [`BaseAvatar--${this.size}`]: this.size,
      }
    },

    styles() {
      if (!this.image.focalPoint) return

      const xPoint = `${this.image.focalPoint.x * 100}%`
      const yPoint = `${this.image.focalPoint.y * 100}%`

      return { objectPosition: `${xPoint} ${yPoint}` }
    },
  },
}
</script>

<style lang="postcss">
.BaseAvatar {
  display: inline-block;
  height: 40px;
  width: 40px;
  border-radius: 100%;
  object-fit: cover;
}

.BaseAvatar--large {
  @apply h-lg
    w-lg;
}
</style>
